'use client';

import type {
  GetProposalsServiceRequest,
  GetProposalsServiceResponse,
} from '@musinsa/services-curator';
import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query';
import { curatorQueries } from '../../query-factory';

export const useProposals = (params: Omit<GetProposalsServiceRequest, 'page'>) => {
  return useInfiniteQuery({
    ...curatorQueries.campaigns.proposals(params),
    initialPageParam: 1,
    getNextPageParam: (lastPage: GetProposalsServiceResponse) =>
      lastPage.pagination.hasNextPage ? lastPage.pagination.nextPage : undefined,
    placeholderData: keepPreviousData,
  });
};
